// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "email_account".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { emailProviderValues } from '@borradh-workspace/labels';
/** Response atom for the "email_account" table (1:1 with a DB row, on the wire). */
export const emailAccountAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    provider: z.enum(emailProviderValues),
    email: z.string(),
    displayName: z.string().nullable(),
    isActive: z.boolean(),
    encryptedCredentials: z.string(),
    lastSyncAt: z.string().datetime().nullable(),
    tokenExpiresAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=emailAccount.js.map